(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["account-pref-sync"] && !Shopify.designMode) return;
  try {
    if (!window.__ahirikoPrefSync) {
    window.__ahirikoPrefSync = true;

    const ATTR = {
      dm: '_dm_preference',
      newsletter: '_newsletter',
      kana: '_name_kana',
      gender: '_gender',
    };
    const STORAGE = {
      dm: 'ahiriko_dm_preference',
      newsletter: 'ahiriko_newsletter',
      kana: 'ahiriko_name_kana',
      gender: 'ahiriko_gender',
    };

    const saveAttributes = async (updates) => {
      const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((res) => res.json());
      const attributes = Object.assign({}, cart.attributes || {}, updates);
      Object.keys(STORAGE).forEach((name) => {
        if (updates[ATTR[name]] != null) {
          window.localStorage.setItem(STORAGE[name], String(updates[ATTR[name]]));
        }
      });
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes }),
      });
      if (!res.ok) throw new Error('cart update failed');
    };

    window.ahirikoSavePrefs = saveAttributes;

    const bindPrefForm = (form) => {
      const submit = form.querySelector('[data-pref-submit]');
      const error = form.querySelector('[data-pref-error]');
      const savingLabel = form.getAttribute('data-saving') || '';
      const defaultLabel = submit ? submit.textContent : '';
      const redirect = form.getAttribute('data-redirect') || '';

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (error) error.hidden = true;

        const updates = {};
        form.querySelectorAll('[data-pref-field]').forEach((field) => {
          const key = field.getAttribute('data-pref-field');
          if (!key) return;
          if (field.type === 'radio' && !field.checked) return;
          const value = field.hasAttribute('data-pref-value')
            ? field.getAttribute('data-pref-value')
            : field.value == null
              ? ''
              : String(field.value).trim();
          updates[key] = value;
        });

        if (submit) {
          submit.disabled = true;
          if (savingLabel) submit.textContent = savingLabel;
        }

        try {
          await saveAttributes(updates);
          const marketingForm = document.getElementById('CustomerMarketingForm');
          if (marketingForm && form.hasAttribute('data-sync-marketing')) {
            const selected = form.querySelector('[data-pref-field="_newsletter"]:checked');
            const hidden = marketingForm.querySelector('[name="customer[accepts_marketing]"]');
            if (hidden) hidden.value = selected && selected.value === 'on' ? 'true' : '';
            HTMLFormElement.prototype.submit.call(marketingForm);
            return;
          }
          window.location.href = redirect || window.location.pathname;
        } catch (err) {
          if (error) error.hidden = false;
          if (submit) {
            submit.disabled = false;
            submit.textContent = defaultLabel;
          }
        }
      });
    };

    document.querySelectorAll('[data-account-pref-form]').forEach(bindPrefForm);

    document.querySelectorAll('[data-account-pref]').forEach((el) => {
      if (el.getAttribute('data-pref-ready') === 'true') return;
      const name = el.getAttribute('data-account-pref');
      const stored = window.localStorage.getItem(STORAGE[name] || '');
      if (!stored) return;
      const label = el.getAttribute('data-pref-' + stored);
      el.textContent = label || stored;
    });

    const pending = {};
    Object.keys(STORAGE).forEach((name) => {
      const stored = window.localStorage.getItem(STORAGE[name]);
      if (stored) pending[ATTR[name]] = stored;
    });
    const pendingKeys = Object.keys(pending);
    if (pendingKeys.length) {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then((res) => res.json())
        .then((cart) => {
          const attributes = cart.attributes || {};
          const missing = {};
          pendingKeys.forEach((key) => {
            if (!attributes[key]) missing[key] = pending[key];
          });
          if (Object.keys(missing).length) return saveAttributes(missing);
        })
        .catch(() => {});
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["age-gate"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.Shopify && Shopify.designMode) return;

    var root = document.querySelector('[data-age-gate]');
    if (!root) return;

    var storageKey = 'ahiriko_age_verified';
    var ask = root.querySelector('[data-age-ask]');
    var denied = root.querySelector('[data-age-denied]');
    var yesBtn = root.querySelector('[data-age-yes]');
    var noBtn = root.querySelector('[data-age-no]');

    function isVerified() {
      try {
        return window.localStorage.getItem(storageKey) === '1';
      } catch (err) {
        return false;
      }
    }

    function openGate() {
      root.hidden = false;
      document.body.classList.add('age-gate-open');
    }

    function closeGate() {
      root.hidden = true;
      document.body.classList.remove('age-gate-open');
    }

    function syncGate() {
      if (isVerified()) {
        closeGate();
      } else {
        openGate();
      }
    }

    syncGate();

    if (yesBtn) {
      yesBtn.addEventListener('click', function () {
        try {
          window.localStorage.setItem(storageKey, '1');
        } catch (err) {}
        closeGate();
      });
    }

    if (noBtn) {
      noBtn.addEventListener('click', function () {
        if (ask) ask.hidden = true;
        if (denied) denied.hidden = false;
      });
    }

    window.addEventListener('pageshow', syncGate);
    window.addEventListener('storage', function (event) {
      if (event.key === storageKey) syncGate();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["b2b-order-sheet"] && !Shopify.designMode) return;
  try {
    const b2bUnitText = (root, qty) => {
    const count = Number(qty) || 0;
    if (count >= 12) return root.dataset.priceCase;
    if (count >= 6) return root.dataset.priceMid;
    return root.dataset.priceSmall;
  };

  const b2bTierName = (qty) => {
    const count = Number(qty) || 0;
    if (count >= 12) return 'case';
    if (count >= 6) return 'mid';
    return 'small';
  };

  const b2bSync = (root) => {
    const input = root.querySelector('[data-b2b-qty]');
    if (!input) return;
    const qty = Math.max(0, Number(input.value) || 0);
    input.value = String(qty);
    const unit = root.querySelector('[data-b2b-unit]');
    const text = b2bUnitText(root, qty);
    if (unit) unit.textContent = text;
    const active = b2bTierName(qty);
    root.querySelectorAll('[data-b2b-tier]').forEach((row) => {
      row.classList.toggle('is-current', row.dataset.b2bTier === active);
    });
    const submit = root.querySelector('[type="submit"]') || root.closest('form')?.querySelector('[type="submit"]');
    if (submit && root.dataset.available === 'true') submit.disabled = qty < 1;
    if (root.dataset.embedded === 'true') {
      document.querySelectorAll('[data-sticky-price-mirror]').forEach((mirror) => {
        mirror.textContent = text;
      });
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-b2b-step]');
    if (!button || button.disabled) return;
    const root = button.closest('[data-b2b-order]');
    const input = root?.querySelector('[data-b2b-qty]');
    if (!root || !input) return;
    input.value = String(Math.max(0, (Number(input.value) || 0) + Number(button.dataset.b2bStep)));
    b2bSync(root);
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest?.('[data-b2b-qty]');
    if (!input) return;
    const root = input.closest('[data-b2b-order]');
    if (root) b2bSync(root);
  });

  document.querySelectorAll('[data-b2b-order]').forEach((root) => b2bSync(root));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-gift-wrapping"] && !Shopify.designMode) return;
  try {
    (function () {
    const root = document.querySelector('[data-cart-gift]');
    if (!root) return;

    const panel = root.querySelector('[data-gift-panel]');
    const submitBtn = root.querySelector('[data-gift-submit]');
    const configNode = root.querySelector('[data-gift-config]');
    if (!panel || !configNode) return;

    let config = {};
    try {
      config = JSON.parse(configNode.textContent);
    } catch (error) {
      return;
    }

    const boxesEl = root.querySelector('[data-gift-boxes]');
    const winesEl = root.querySelector('[data-gift-wines]');
    const bagEl = root.querySelector('[data-gift-bag]');
    const capacityEl = root.querySelector('[data-gift-capacity]');
    const errorEl = root.querySelector('[data-gift-error]');
    const noshiEl = root.querySelector('[data-gift-noshi]');
    const wines = (config.wines || []).filter((wine) => wine && wine.title);

    (config.boxes || []).forEach((box) => {
      const label = document.createElement('label');
      label.className = 'cart-gift__radio';
      label.innerHTML =
        '<input type="radio" name="gift-box" value="' +
        String(box.id) +
        '" data-capacity="' +
        String(box.capacity) +
        '"><span>' +
        box.label +
        '（' +
        box.price +
        '）</span>';
      boxesEl.appendChild(label);
    });

    wines.forEach((wine) => {
      const label = document.createElement('label');
      label.className = 'cart-gift__wine';
      label.innerHTML =
        '<input type="number" min="0" max="' +
        String(wine.quantity) +
        '" value="0" data-wine-title="' +
        wine.title.replace(/"/g, '&quot;') +
        '" data-wine-key="' +
        String(wine.key || '').replace(/"/g, '&quot;') +
        '" data-wine-id="' +
        String(wine.id || '') +
        '"><span>' +
        wine.title +
        '（' +
        String(wine.quantity) +
        '）</span>';
      winesEl.appendChild(label);
    });

    (config.bags || []).forEach((bag) => {
      const option = document.createElement('option');
      option.value = String(bag.id);
      option.textContent = bag.label;
      bagEl.appendChild(option);
    });

    function selectedType() {
      return root.querySelector('input[name="gift-type"]:checked')?.value || '';
    }

    function selectedBox() {
      const input = root.querySelector('input[name="gift-box"]:checked');
      if (!input) return null;
      return {
        id: Number(input.value),
        capacity: Number(input.getAttribute('data-capacity') || '1'),
      };
    }

    function updateCapacity() {
      if (!capacityEl) return;
      const type = selectedType();
      const labels = config.labels || {};
      if (type === 'cellophane') {
        capacityEl.textContent = labels.cellophaneCapacity || '';
        return;
      }
      const box = selectedBox();
      if (!box) {
        capacityEl.textContent = '';
        return;
      }
      const template = labels.capacity || '';
      capacityEl.textContent = template.replace('__COUNT__', String(box.capacity));
    }

    function syncSteps() {
      const type = selectedType();
      const box = selectedBox();
      const boxStep = root.querySelector('[data-gift-step-box]');
      const winesStep = root.querySelector('[data-gift-step-wines]');
      const optionsStep = root.querySelector('[data-gift-step-options]');
      const wrapOptions = root.querySelector('[data-gift-wrap-options]');
      const optionsHeading = root.querySelector('[data-gift-options-heading]');
      const labels = config.labels || {};
      const isBox = type === 'box';
      const isCellophane = type === 'cellophane';
      const ready = isCellophane || (isBox && !!box);

      if (boxStep) boxStep.hidden = !isBox;
      if (winesStep) winesStep.hidden = !ready;
      if (optionsStep) optionsStep.hidden = !ready;
      if (wrapOptions) wrapOptions.hidden = !isBox;
      if (optionsHeading) {
        optionsHeading.textContent = isCellophane
          ? labels.stepBag || labels.stepOptions || ''
          : labels.stepOptions || '';
      }
      if (!isBox && noshiEl) noshiEl.hidden = true;
      updateCapacity();
    }

    function selectedWines() {
      return Array.from(root.querySelectorAll('[data-wine-title]'))
        .map((input) => ({
          title: input.getAttribute('data-wine-title'),
          quantity: Number(input.value || '0'),
          key: input.getAttribute('data-wine-key') || '',
          id: Number(input.getAttribute('data-wine-id') || '0'),
          max: Number(input.getAttribute('max') || '0'),
        }))
        .filter((wine) => wine.quantity > 0);
    }

    function showError(message) {
      if (!errorEl) return;
      errorEl.hidden = !message;
      errorEl.textContent = message || '';
    }

    root.querySelectorAll('input[name="gift-type"]').forEach((input) => {
      input.addEventListener('change', syncSteps);
    });
    root.querySelectorAll('input[name="gift-box"]').forEach((input) => {
      input.addEventListener('change', syncSteps);
    });

    function noshiTypeLabel(value) {
      if (!value) return '';
      const cut = value.indexOf('（');
      return cut > 0 ? value.slice(0, cut) : value;
    }

    function limitField(field) {
      const maxChars = Number(field.getAttribute('maxlength') || '0');
      const maxLines = Number(field.getAttribute('data-max-lines') || '0');
      let value = (field.value || '').replace(/\r/g, '');
      if (maxChars > 0 && value.length > maxChars) {
        value = value.slice(0, maxChars);
      }
      if (maxLines > 0) {
        const lines = value.split('\n');
        if (lines.length > maxLines) {
          value = lines.slice(0, maxLines).join('\n');
        }
      }
      if (field.value !== value) field.value = value;
      return value;
    }

    function updateNoshiCount(field) {
      const countEl = root.querySelector('[data-gift-count-for="' + field.id + '"]');
      if (!countEl) return;
      const template = countEl.getAttribute('data-count-template') || '';
      countEl.textContent = template.replace('__COUNT__', String(field.value.length));
    }

    function noshiMizuhiki(value) {
      if (!value) return 'hanamusubi';
      if (value.indexOf('黒白') !== -1) return 'mourning';
      if (value.indexOf('結びきり') !== -1) return 'musubikiri';
      return 'hanamusubi';
    }

    function updateNoshiPreview() {
      const typeEl = root.querySelector('[data-gift-noshi-preview-type]');
      const nameEl = root.querySelector('[data-gift-noshi-preview-name]');
      const katagakiEl = root.querySelector('[data-gift-noshi-preview-katagaki]');
      const paper = root.querySelector('[data-gift-noshi-paper]');
      const inscription = root.querySelector('[data-gift-inscription]')?.value || '';
      const name = root.querySelector('[data-gift-name]')?.value || '';
      const katagaki = root.querySelector('[data-gift-katagaki]')?.value || '';
      if (typeEl) typeEl.textContent = noshiTypeLabel(inscription);
      if (katagakiEl) katagakiEl.textContent = katagaki;
      if (nameEl) nameEl.textContent = name;
      if (paper) paper.setAttribute('data-mizuhiki', noshiMizuhiki(inscription));
    }

    function bindNoshiField(field) {
      if (!field) return;
      const onChange = () => {
        limitField(field);
        updateNoshiCount(field);
        updateNoshiPreview();
      };
      field.addEventListener('input', onChange);
      onChange();
    }

    bindNoshiField(root.querySelector('[data-gift-name]'));
    bindNoshiField(root.querySelector('[data-gift-katagaki]'));
    root.querySelector('[data-gift-inscription]')?.addEventListener('change', updateNoshiPreview);
    updateNoshiPreview();

    root.querySelectorAll('input[name="gift-wrap-style"]').forEach((input) => {
      input.addEventListener('change', () => {
        const selected = root.querySelector('input[name="gift-wrap-style"]:checked');
        if (noshiEl) noshiEl.hidden = selected?.value !== '熨斗';
        if (selected?.value === '熨斗') updateNoshiPreview();
      });
    });

    async function cartJson(url, body) {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await response.json().catch(() => null);
      if (!response.ok || !data || data.status === 422) throw new Error('cart request failed');
      return data;
    }

    function selectedBagItem() {
      const bagId = root.querySelector('[data-gift-bag]')?.value;
      if (!bagId) return null;
      return {
        id: Number(bagId),
        quantity: 1,
        properties: { 用途: 'ギフト紙袋' },
      };
    }

    async function applyCellophaneWrapping(winesSelected) {
      if (!config.cellophaneVariantId) throw new Error('missing cellophane');
      const items = [
        {
          id: Number(config.cellophaneVariantId),
          quantity: 1,
          properties: {
            ラッピング: 'セロファン包装',
            セットするワイン: winesSelected
              .map((wine) => wine.title + ' ×' + wine.quantity)
              .join('、'),
          },
        },
      ];
      const bag = selectedBagItem();
      if (bag) items.push(bag);
      await cartJson(config.cartAddUrl, { items });
    }

    submitBtn?.addEventListener('click', async () => {
      const labels = config.labels || {};
      const type = selectedType();
      const box = selectedBox();
      const winesSelected = selectedWines();
      const bottleCount = winesSelected.reduce((sum, wine) => sum + wine.quantity, 0);

      if (!type) {
        showError(labels.typeRequired || '');
        return;
      }
      if (type === 'box' && !box) {
        showError(labels.boxRequired || '');
        return;
      }
      if (bottleCount < 1) {
        showError(labels.wineRequired || '');
        return;
      }
      if (type === 'box' && bottleCount > box.capacity) {
        showError(labels.capacityError || '');
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = labels.adding || labels.add;
      showError('');

      try {
        if (type === 'cellophane') {
          await applyCellophaneWrapping(winesSelected);
          window.location.href = config.cartUrl;
          return;
        }

        const wrapStyle = root.querySelector('input[name="gift-wrap-style"]:checked')?.value || '';
        const properties = {
          セットするワイン: winesSelected
            .map((wine) => wine.title + ' ×' + wine.quantity)
            .join('、'),
        };
        if (wrapStyle) properties['ラッピング'] = wrapStyle;
        if (wrapStyle === '熨斗') {
          const inscription = root.querySelector('[data-gift-inscription]')?.value || '';
          const name = root.querySelector('[data-gift-name]')?.value.trim() || '';
          const katagaki = root.querySelector('[data-gift-katagaki]')?.value.trim() || '';
          properties['熨斗表書き'] = inscription;
          if (name) properties['名入れ'] = name;
          if (katagaki) properties['肩書き'] = katagaki;
        }

        const items = [{ id: box.id, quantity: 1, properties }];
        const bag = selectedBagItem();
        if (bag) items.push(bag);

        await cartJson(config.cartAddUrl, { items });
        window.location.href = config.cartUrl;
      } catch (error) {
        showError(labels.genericError || '');
        submitBtn.disabled = false;
        submitBtn.textContent = labels.add;
      }
    });

    syncSteps();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-filter-options"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-price-band]').forEach((button) => {
    button.addEventListener('click', () => {
      const form = button.closest('form');
      if (!form) return;
      const minName = button.dataset.minName;
      const maxName = button.dataset.maxName;
      const minInput = minName ? form.querySelector(`[name="${minName}"]`) : null;
      const maxInput = maxName ? form.querySelector(`[name="${maxName}"]`) : null;
      if (minInput) minInput.value = button.dataset.minValue || '';
      if (maxInput) maxInput.value = button.dataset.maxValue || '';
      form.submit();
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["customer-age-validation"] && !Shopify.designMode) return;
  try {
    if (!window.__ahirikoBirthdateInit) {
    window.__ahirikoBirthdateInit = true;

    const STORAGE_KEY = 'ahiriko_birthdate';
    const ATTR_KEY = '_birthdate';

    const adultCutoff = () => {
      const cutoff = new Date();
      cutoff.setFullYear(cutoff.getFullYear() - 20);
      cutoff.setHours(23, 59, 59, 999);
      return cutoff;
    };

    const toIso = (value) => {
      if (!value) return '';
      const compact = String(value).trim().replace(/[/.]/g, '-');
      const match = compact.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
      if (!match) return '';
      return `${match[1]}-${match[2].padStart(2, '0')}-${match[3].padStart(2, '0')}`;
    };

    const isAdultBirthdate = (value) => {
      const iso = toIso(value);
      if (!iso) return false;
      const birth = new Date(`${iso}T00:00:00`);
      return !Number.isNaN(birth.getTime()) && birth <= adultCutoff();
    };

    const yyyyMmDd = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const saveBirthdate = async (iso) => {
      window.localStorage.setItem(STORAGE_KEY, iso);
      const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((res) => res.json());
      const attributes = Object.assign({}, cart.attributes || {});
      attributes[ATTR_KEY] = iso;
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes }),
      });
      if (!res.ok) throw new Error('cart update failed');
    };

    const bindForm = (form) => {
      const input = form.querySelector('[data-customer-birthdate]');
      if (!input) return;
      const error = form.querySelector('[data-customer-age-error]');
      const saveError = form.querySelector('[data-customer-age-save-error]');
      const submit = form.querySelector('[data-birthdate-submit]');
      const savingLabel = form.getAttribute('data-saving') || '';
      const saveErrorLabel = form.getAttribute('data-save-error') || '';
      const defaultLabel = submit ? submit.textContent : '';

      input.setAttribute('max', yyyyMmDd(adultCutoff()));

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const iso = toIso(input.value);
        input.value = iso;

        if (!isAdultBirthdate(iso)) {
          if (error) error.hidden = false;
          if (saveError) saveError.hidden = true;
          input.focus();
          return;
        }

        if (error) error.hidden = true;
        if (saveError) saveError.hidden = true;
        if (submit) {
          submit.disabled = true;
          if (savingLabel) submit.textContent = savingLabel;
        }

        try {
          await saveBirthdate(iso);
          const prompt = document.querySelector('[data-birthdate-prompt]');
          if (prompt) prompt.hidden = true;
          window.location.reload();
        } catch (err) {
          if (saveError) {
            saveError.textContent = saveErrorLabel;
            saveError.hidden = false;
          }
          if (submit) {
            submit.disabled = false;
            submit.textContent = defaultLabel;
          }
        }
      });
    };

    document.querySelectorAll('[data-birthdate-form]').forEach(bindForm);

    const stored = toIso(window.localStorage.getItem(STORAGE_KEY) || '');
    const prompt = document.querySelector('[data-birthdate-prompt]');
    const syncKey = 'ahiriko_birthdate_synced';
    if (stored && isAdultBirthdate(stored) && prompt && !prompt.hidden) {
      if (window.sessionStorage.getItem(syncKey) !== stored) {
        window.sessionStorage.setItem(syncKey, stored);
        saveBirthdate(stored)
          .then(() => window.location.reload())
          .catch(() => {});
      }
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["event-apply"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.getElementById('event-apply');
    if (!root) return;

    var key = 'ahiriko_event_rsvps';
    var handle = root.getAttribute('data-event-handle');
    var list = [];
    try {
      list = JSON.parse(window.localStorage.getItem(key) || '[]');
    } catch (err) {
      list = [];
    }
    if (!Array.isArray(list)) list = [];

    var payloadNode = document.querySelector('[data-event-rsvp-payload]');
    if (payloadNode) {
      try {
        var payload = JSON.parse(payloadNode.textContent);
        if (payload && payload.handle) {
          payload.appliedAt = new Date().toISOString();
          try {
            var pending = JSON.parse(window.sessionStorage.getItem('ahiriko_event_rsvp_pending') || '{}');
            if (pending && pending.handle === payload.handle) {
              payload.guests = pending.guests || payload.guests;
              payload.name = pending.name || payload.name;
              payload.email = pending.email || payload.email;
              payload.note = pending.note || payload.note;
            }
            window.sessionStorage.removeItem('ahiriko_event_rsvp_pending');
          } catch (err) {}
          list = list.filter(function (item) {
            return item && item.handle !== payload.handle;
          });
          list.unshift(payload);
          window.localStorage.setItem(key, JSON.stringify(list));
          fetch('/cart.js', { credentials: 'same-origin' })
            .then(function (res) { return res.json(); })
            .then(function (cart) {
              var attributes = Object.assign({}, cart.attributes || {});
              attributes._event_rsvps = JSON.stringify(list);
              return fetch('/cart/update.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ attributes: attributes })
              });
            })
            .catch(function () {});
        }
      } catch (err) {}
      return;
    }

    var applied = list.some(function (item) {
      return item && item.handle === handle;
    });
    if (applied) {
      var formWrap = root.querySelector('[data-event-apply-form]');
      var notice = root.querySelector('[data-event-applied]');
      if (formWrap) formWrap.hidden = true;
      if (notice) notice.hidden = false;
      return;
    }

    var form = root.querySelector('.event-apply__form');
    if (!form) return;

    form.addEventListener('submit', function (event) {
      var guests = form.querySelector('#EventApplyGuests');
      var name = form.querySelector('#EventApplyName');
      var email = form.querySelector('#EventApplyEmail');
      var note = form.querySelector('#EventApplyBody');
      var errorNode = root.querySelector('[data-event-apply-error]');
      var submit = form.querySelector('[type="submit"]');
      window.sessionStorage.setItem(
        'ahiriko_event_rsvp_pending',
        JSON.stringify({
          handle: handle,
          guests: guests ? guests.value : '',
          name: name ? name.value : '',
          email: email ? email.value : '',
          note: note ? note.value : '',
        })
      );

      if (typeof window.ahirikoSubmitEventRsvp !== 'function') return;

      event.preventDefault();
      if (errorNode) {
        errorNode.hidden = true;
        errorNode.textContent = '';
      }
      if (submit) submit.disabled = true;

      window
        .ahirikoSubmitEventRsvp({
          handle: handle,
          title: root.getAttribute('data-event-title') || '',
          url: root.getAttribute('data-event-url') || '',
          date: root.getAttribute('data-event-date') || '',
          time: root.getAttribute('data-event-time') || '',
          startsAt: root.getAttribute('data-event-starts') || '',
          guests: guests ? guests.value : '1',
          name: name ? name.value : '',
          email: email ? email.value : '',
          note: note ? note.value : '',
          action: 'apply',
        })
        .catch(function () {
          if (submit) submit.disabled = false;
          form.submit();
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["event-gallery"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-event-gallery]').forEach((carousel) => {
    const viewport = carousel.querySelector('[data-event-gallery-viewport]');
    const track = carousel.querySelector('[data-event-gallery-track]');
    const slides = Array.from(carousel.querySelectorAll('[data-event-gallery-slide]'));
    const dots = carousel.querySelectorAll('[data-event-gallery-dot]');
    const prevButton = carousel.querySelector('[data-event-gallery-prev]');
    const nextButton = carousel.querySelector('[data-event-gallery-next]');
    const realCount =
      Number(carousel.dataset.slideCount) ||
      slides.filter((slide) => !slide.hasAttribute('data-event-gallery-clone')).length;

    if (!viewport || !track || realCount <= 1) return;

    const hasClones = slides.some((slide) => slide.hasAttribute('data-event-gallery-clone'));
    let position = hasClones ? 1 : 0;
    let isJumping = false;

    const setActive = (realIndex) => {
      slides.forEach((slide) => {
        const idx = Number(slide.dataset.realIndex);
        const isClone = slide.hasAttribute('data-event-gallery-clone');
        slide.classList.toggle('is-active', !isClone && idx === realIndex);
      });

      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === realIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    };

    const applyTransform = (index, instant) => {
      const slideWidth = slides[0].getBoundingClientRect().width;
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      const viewportWidth = viewport.clientWidth;
      const offset = index * (slideWidth + gap) - (viewportWidth - slideWidth) / 2;

      track.style.transition = instant ? 'none' : 'transform 0.45s ease';
      track.style.transform = `translateX(${-offset}px)`;

      if (instant) {
        track.offsetHeight;
        track.style.transition = 'transform 0.45s ease';
      }
    };

    const goToPosition = (nextPosition, instant = false) => {
      position = nextPosition;
      applyTransform(position, instant);

      let realIndex = position;
      if (hasClones) {
        if (position === 0) realIndex = realCount - 1;
        else if (position === realCount + 1) realIndex = 0;
        else realIndex = position - 1;
      }

      setActive(realIndex);
    };

    const goToReal = (realIndex) => {
      goToPosition(hasClones ? realIndex + 1 : realIndex);
    };

    const step = (delta) => {
      goToPosition(position + delta);
    };

    track.addEventListener('transitionend', (event) => {
      if (event.target !== track || isJumping || !hasClones) return;

      if (position === 0) {
        isJumping = true;
        goToPosition(realCount, true);
        isJumping = false;
      } else if (position === realCount + 1) {
        isJumping = true;
        goToPosition(1, true);
        isJumping = false;
      }
    });

    prevButton?.addEventListener('click', (event) => {
      event.preventDefault();
      step(-1);
    });

    nextButton?.addEventListener('click', (event) => {
      event.preventDefault();
      step(1);
    });

    dots.forEach((dot) => {
      dot.addEventListener('click', (event) => {
        event.preventDefault();
        goToReal(Number(dot.dataset.index));
      });
    });

    window.addEventListener('resize', () => goToPosition(position, true));

    let touchStartX = 0;
    viewport.addEventListener(
      'touchstart',
      (event) => {
        touchStartX = event.changedTouches[0]?.clientX || 0;
      },
      { passive: true }
    );
    viewport.addEventListener(
      'touchend',
      (event) => {
        const delta = (event.changedTouches[0]?.clientX || 0) - touchStartX;
        if (Math.abs(delta) >= 40) {
          step(delta < 0 ? 1 : -1);
        }
      },
      { passive: true }
    );

    goToPosition(position, true);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["event-rsvp-to-checkout"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.ahirikoSubmitEventRsvp) return;

    var config = function () {
      return document.querySelector('[data-event-rsvp-to-checkout]');
    };

    var jsonFetch = function (url, body) {
      return fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            throw new Error(data.description || data.message || 'request failed');
          }
          return data;
        });
      });
    };

    window.ahirikoSubmitEventRsvp = function (payload) {
      var root = config();
      var variantId = root ? Number(root.getAttribute('data-variant-id')) : 0;
      var checkoutUrl = root ? root.getAttribute('data-checkout-url') || '/checkout' : '/checkout';
      if (!variantId) return Promise.reject(new Error('missing variant'));

      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          var updates = {};
          (cart.items || []).forEach(function (item) {
            var props = item.properties || {};
            var handle = props._event_handle || props['_event_handle'];
            if (handle && payload.handle && handle === payload.handle) {
              updates[item.key] = 0;
            }
          });
          if (Object.keys(updates).length) {
            return jsonFetch('/cart/update.js', { updates: updates });
          }
          return cart;
        })
        .then(function () {
          var rootEl = config();
          var dateTime = [payload.date, payload.time].filter(Boolean).join('／');
          var guests = String(payload.guests || '1');
          var name = payload.name || (rootEl && rootEl.getAttribute('data-customer-name')) || '';
          var email = payload.email || (rootEl && rootEl.getAttribute('data-customer-email')) || '';
          var title = payload.title || '';
          var actionLabel = payload.action === 'update' ? '予約変更' : '新規予約';
          var summary = [name, title, guests + '名', dateTime].filter(Boolean).join(' ／ ');
          return jsonFetch('/cart/add.js', {
            items: [
              {
                id: variantId,
                quantity: 1,
                properties: {
                  '_event_handle': payload.handle || '',
                  '_event_starts_at': payload.startsAt || '',
                  '_event_url': payload.url || '',
                  '_event_action': payload.action || 'apply',
                  '_event_guests': guests,
                  '予約内容': summary,
                  '予約区分': actionLabel,
                  'イベント': title,
                  '予約者': name,
                  'お名前': name,
                  'メール': email,
                  '日時': dateTime,
                  '参加人数': guests + '名',
                  'ご連絡事項': payload.note || '',
                },
              },
            ],
          });
        })
        .then(function () {
          return fetch('/cart.js', { credentials: 'same-origin' }).then(function (res) {
            return res.json();
          });
        })
        .then(function (cart) {
          var lines = (cart.items || []).filter(function (item) {
            var props = item.properties || {};
            return props._event_handle || props['イベント'] || props['予約内容'];
          });
          var summaries = lines.map(function (item) {
            var props = item.properties || {};
            return (
              props['予約内容'] ||
              [props['予約者'] || props['お名前'], props['イベント'], props['参加人数'], props['日時']]
                .filter(Boolean)
                .join(' ／ ')
            );
          });
          var ledgerNote = summaries
            .map(function (row) {
              return '【イベント予約】' + row;
            })
            .join('\n');
          var existingNote = cart.note || '';
          var nextNote = existingNote
            .split('\n')
            .filter(function (line) {
              return line.indexOf('【イベント予約】') !== 0;
            })
            .join('\n')
            .replace(/^\n+|\n+$/g, '');
          nextNote = [nextNote, ledgerNote].filter(Boolean).join('\n');

          var attributes = Object.assign({}, cart.attributes || {});
          var first = (lines[0] && lines[0].properties) || {};
          attributes['予約イベント'] = lines
            .map(function (item) {
              return (item.properties || {})['イベント'] || '';
            })
            .filter(Boolean)
            .join(' ／ ');
          attributes['予約者'] = lines
            .map(function (item) {
              return (item.properties || {})['予約者'] || (item.properties || {})['お名前'] || '';
            })
            .filter(Boolean)
            .join(' ／ ');
          attributes['参加人数'] = first['参加人数'] || '';
          attributes['開催日時'] = first['日時'] || '';
          if (first['メール']) attributes['予約者メール'] = first['メール'];

          return jsonFetch('/cart/update.js', {
            note: nextNote,
            attributes: attributes,
          });
        })
        .then(function () {
          window.location.href = checkoutUrl;
        });
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-set-images"] && !Shopify.designMode) return;
  try {
    (function () {
    var MARK = 'data-bottles-normalized';
    var HIRES_WIDTH = '1200';

    function isInk(r, g, b, a) {
      if (a < 28) return false;
      return 0.2126 * r + 0.7152 * g + 0.0722 * b < 246;
    }

    function bottleBox(img) {
      var nw = img.naturalWidth;
      var nh = img.naturalHeight;
      if (!nw || !nh) return null;

      var dw = Math.min(240, nw);
      var dh = Math.max(1, Math.round(nh * (dw / nw)));
      var canvas = document.createElement('canvas');
      canvas.width = dw;
      canvas.height = dh;
      var ctx = canvas.getContext('2d', { willReadFrequently: true });
      if (!ctx) return null;
      ctx.drawImage(img, 0, 0, dw, dh);

      var data;
      try {
        data = ctx.getImageData(0, 0, dw, dh).data;
      } catch (error) {
        return null;
      }

      var cols = new Array(dw);
      var minYs = new Array(dw);
      var maxYs = new Array(dw);
      var x;
      var y;
      var i;
      var maxC = 0;

      for (x = 0; x < dw; x += 1) {
        cols[x] = 0;
        minYs[x] = dh;
        maxYs[x] = -1;
      }

      for (y = 0; y < dh; y += 1) {
        for (x = 0; x < dw; x += 1) {
          i = (y * dw + x) * 4;
          if (!isInk(data[i], data[i + 1], data[i + 2], data[i + 3])) continue;
          cols[x] += 1;
          if (y < minYs[x]) minYs[x] = y;
          if (y > maxYs[x]) maxYs[x] = y;
        }
      }

      for (x = 0; x < dw; x += 1) {
        if (cols[x] > maxC) maxC = cols[x];
      }
      if (maxC < 4) return null;

      var thr = Math.max(4, maxC * 0.2);
      var bestStart = 0;
      var bestEnd = -1;
      var bestLen = 0;
      var runStart = -1;

      for (x = 0; x <= dw; x += 1) {
        if (x < dw && cols[x] >= thr) {
          if (runStart < 0) runStart = x;
        } else if (runStart >= 0) {
          if (x - runStart > bestLen) {
            bestLen = x - runStart;
            bestStart = runStart;
            bestEnd = x - 1;
          }
          runStart = -1;
        }
      }

      if (bestEnd < 0) return null;

      var minX = bestStart;
      var maxX = bestEnd;
      var minY = dh;
      var maxY = -1;

      for (x = minX; x <= maxX; x += 1) {
        if (maxYs[x] < 0) continue;
        if (minYs[x] < minY) minY = minYs[x];
        if (maxYs[x] > maxY) maxY = maxYs[x];
      }
      if (maxY < 0) return null;

      var pad = Math.round(Math.max(dw, dh) * 0.015);
      minX = Math.max(0, minX - pad);
      minY = Math.max(0, minY - pad);
      maxX = Math.min(dw - 1, maxX + pad);
      maxY = Math.min(dh - 1, maxY + pad);

      return {
        fracH: (maxY - minY + 1) / dh,
        fracW: (maxX - minX + 1) / dw,
        cx: (minX + maxX) / 2 / dw,
        cy: (minY + maxY) / 2 / dh,
      };
    }

    function clearScale(img) {
      var item = img.closest('.product-set-images__item');
      if (!item) return;
      item.style.removeProperty('--bottle-scale');
      item.style.removeProperty('--bottle-origin');
    }

    function sourceUrl(src) {
      try {
        var url = new URL(src, window.location.href);
        url.searchParams.delete('width');
        url.searchParams.delete('height');
        url.searchParams.delete('crop');
        url.searchParams.set('width', HIRES_WIDTH);
        return url.toString();
      } catch (error) {
        return src;
      }
    }

    function loadHiRes(img) {
      var src = img.currentSrc || img.src;
      if (!src || src.indexOf('data:') === 0) return Promise.resolve(img);

      return new Promise(function (resolve) {
        var settled = false;
        var hi = new Image();
        var finish = function (source) {
          if (settled) return;
          settled = true;
          resolve(source);
        };
        hi.crossOrigin = 'anonymous';
        hi.onload = function () {
          finish(hi.naturalWidth ? hi : img);
        };
        hi.onerror = function () {
          finish(img);
        };
        setTimeout(function () {
          finish(img);
        }, 2500);
        hi.src = sourceUrl(src);
      });
    }

    function cropBottleContent(target, source) {
      if (target.dataset.bottleCropped === '1') return;
      if (!source || !source.naturalWidth || !source.naturalHeight) return;

      var nw = source.naturalWidth;
      var nh = source.naturalHeight;
      var outH = 520;
      var outW = Math.round(outH * (9 / 22));
      var canvas = document.createElement('canvas');
      canvas.width = outW;
      canvas.height = outH;
      var ctx = canvas.getContext('2d');
      if (!ctx) return;

      ctx.clearRect(0, 0, outW, outH);

      var sx = 0;
      var sy = 0;
      var sw = nw;
      var sh = nh;
      var box = bottleBox(source);
      if (box && box.fracH >= 0.12 && box.fracW >= 0.05) {
        var padX = 0.03;
        var padY = 0.006;
        sx = Math.max(0, (box.cx - box.fracW / 2 - padX) * nw);
        sy = Math.max(0, (box.cy - box.fracH / 2 - padY) * nh);
        sw = Math.min(nw - sx, (box.fracW + padX * 2) * nw);
        sh = Math.min(nh - sy, (box.fracH + padY * 2) * nh);
      }
      if (sw < 8 || sh < 8) {
        sx = 0;
        sy = 0;
        sw = nw;
        sh = nh;
      }

      var scale = outH / sh;
      if (sw * scale > outW * 1.35) {
        scale = outW / sw;
      }
      var dw = sw * scale;
      var dh = sh * scale;
      var dx = (outW - dw) / 2;
      var dy = outH - dh;
      ctx.drawImage(source, sx, sy, sw, sh, dx, dy, dw, dh);

      try {
        target.dataset.bottleCropped = '1';
        clearScale(target);
        target.removeAttribute('srcset');
        target.removeAttribute('sizes');
        target.src = canvas.toDataURL('image/png');
      } catch (error) {
        target.dataset.bottleCropped = '0';
      }
    }

    function shouldCropInsteadOfScale(img) {
      return !!img.closest('.wine-gift-card, .product-card--set, .wine-list-row--set, .shopkeeper-picks .product-card--v2');
    }

    function normalizeImage(img) {
      if (!shouldCropInsteadOfScale(img)) {
        clearScale(img);
        return Promise.resolve();
      }

      return loadHiRes(img).then(function (source) {
        cropBottleContent(img, source);
        clearScale(img);
      }).catch(function () {
        clearScale(img);
      });
    }

    function whenReady(img) {
      if (img.complete && img.naturalWidth) {
        return Promise.resolve(img);
      }
      return new Promise(function (resolve) {
        img.addEventListener('load', function () { resolve(img); }, { once: true });
        img.addEventListener('error', function () { resolve(img); }, { once: true });
      });
    }

    function normalizeSet(root) {
      if (!root || root.getAttribute(MARK)) return;
      var imgs = root.querySelectorAll('.product-set-images__item img');
      if (!imgs.length) return;
      root.setAttribute(MARK, 'pending');

      Promise.all(Array.prototype.map.call(imgs, whenReady)).then(function () {
        return Promise.all(Array.prototype.map.call(imgs, function (img) {
          return normalizeImage(img);
        }));
      }).then(function () {
        root.setAttribute(MARK, '1');
      });
    }

    function normalizeSingle(img) {
      if (!img || img.dataset.bottleCropped || img.closest('.product-set-images')) return;
      whenReady(img).then(function () {
        return normalizeImage(img);
      });
    }

    function scan(scope) {
      var root = scope || document;
      root.querySelectorAll('.product-set-images').forEach(normalizeSet);
      root.querySelectorAll('.shopkeeper-picks .product-card--v2:not(.product-card--set) .product-card__media img').forEach(normalizeSingle);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scan(document); });
    } else {
      scan(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      scan(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["subscription-prefs-form"] && !Shopify.designMode) return;
  try {
    (function () {
    const root = document.querySelector('[data-subscription-manage]');
    if (!root) return;

    const state = {
      bottles: Number(root.getAttribute('data-bottles')) || 3,
      typeMode: root.getAttribute('data-type-mode') || 'omakase',
      tasteMode: root.getAttribute('data-taste-mode') || 'omakase',
      types: {
        red: Number(root.getAttribute('data-red')) || 0,
        white: Number(root.getAttribute('data-white')) || 0,
        sparkling: Number(root.getAttribute('data-sparkling')) || 0,
        rose: Number(root.getAttribute('data-rose')) || 0
      },
      cycle: Number(root.getAttribute('data-cycle')) || 4
    };

    const typeCustom = root.querySelector('[data-manage-type-custom]');
    const tasteCustom = root.querySelector('[data-manage-taste-custom]');
    const typeSummary = root.querySelector('[data-manage-type-summary]');
    const bodyField = root.querySelector('[data-manage-body]');
    const form = root.querySelector('form');

    function typeTotal() {
      return state.types.red + state.types.white + state.types.sparkling + state.types.rose;
    }

    function canInc(type) {
      if (typeTotal() >= state.bottles) return false;
      if (type === 'sparkling' && state.types.sparkling >= 1) return false;
      if (type === 'rose' && state.types.rose >= 1) return false;
      return true;
    }

    function renderTypes() {
      if (typeCustom) typeCustom.hidden = state.typeMode !== 'custom';
      root.querySelectorAll('[data-manage-type]').forEach((row) => {
        const type = row.getAttribute('data-manage-type');
        row.querySelector('[data-manage-value]').textContent = String(state.types[type]);
        row.querySelector('[data-manage-dec]').disabled = state.types[type] <= 0;
        row.querySelector('[data-manage-inc]').disabled = !canInc(type);
      });
      if (!typeSummary) return;
      if (state.typeMode === 'omakase') {
        typeSummary.textContent = '';
        typeSummary.classList.remove('is-invalid');
        return;
      }
      typeSummary.textContent = typeTotal() + ' / ' + state.bottles;
      typeSummary.classList.toggle('is-invalid', typeTotal() !== state.bottles);
    }

    function selectGroup(selector, attr, value) {
      root.querySelectorAll(selector).forEach((btn) => {
        btn.classList.toggle('is-selected', btn.getAttribute(attr) === String(value));
      });
    }

    root.querySelectorAll('[data-manage-bottles]').forEach((btn) => {
      btn.addEventListener('click', () => {
        state.bottles = Number(btn.getAttribute('data-manage-bottles'));
        selectGroup('[data-manage-bottles]', 'data-manage-bottles', state.bottles);
        Object.keys(state.types).forEach((k) => {
          state.types[k] = 0;
        });
        renderTypes();
      });
    });

    root.querySelectorAll('[data-manage-type-mode]').forEach((btn) => {
      btn.addEventListener('click', () => {
        state.typeMode = btn.getAttribute('data-manage-type-mode');
        selectGroup('[data-manage-type-mode]', 'data-manage-type-mode', state.typeMode);
        renderTypes();
      });
    });

    root.querySelectorAll('[data-manage-taste-mode]').forEach((btn) => {
      btn.addEventListener('click', () => {
        state.tasteMode = btn.getAttribute('data-manage-taste-mode');
        selectGroup('[data-manage-taste-mode]', 'data-manage-taste-mode', state.tasteMode);
        if (tasteCustom) tasteCustom.hidden = state.tasteMode !== 'custom';
      });
    });

    root.querySelectorAll('[data-manage-cycle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        state.cycle = Number(btn.getAttribute('data-manage-cycle'));
        selectGroup('[data-manage-cycle]', 'data-manage-cycle', state.cycle);
      });
    });

    root.querySelectorAll('[data-manage-type]').forEach((row) => {
      const type = row.getAttribute('data-manage-type');
      row.querySelector('[data-manage-inc]').addEventListener('click', () => {
        if (!canInc(type)) return;
        state.types[type] += 1;
        renderTypes();
      });
      row.querySelector('[data-manage-dec]').addEventListener('click', () => {
        if (state.types[type] <= 0) return;
        state.types[type] -= 1;
        renderTypes();
      });
    });

    root.querySelectorAll('[data-manage-taste-group]').forEach((group) => {
      group.querySelectorAll('input').forEach((input) => {
        input.addEventListener('change', () => {
          group.querySelectorAll('.subscription-taste-option').forEach((opt) => opt.classList.remove('is-selected'));
          input.closest('.subscription-taste-option').classList.add('is-selected');
        });
      });
    });

    if (form) {
      form.addEventListener('submit', (event) => {
        if (state.typeMode === 'custom' && typeTotal() !== state.bottles) {
          event.preventDefault();
          if (typeSummary) {
            typeSummary.classList.add('is-invalid');
            typeSummary.textContent = typeTotal() + ' / ' + state.bottles;
          }
          return;
        }
        const tasteRed = (root.querySelector('[data-manage-taste-group="red"] input:checked') || {}).value || 'おまかせ';
        const tasteWhite = (root.querySelector('[data-manage-taste-group="white"] input:checked') || {}).value || 'おまかせ';
        const skip = root.querySelector('[data-manage-skip]');
        const note = root.querySelector('[data-manage-note]');
        const lines = [
          '定期便の条件変更',
          'お届け本数: ' + state.bottles + '本',
          'タイプ: ' + (state.typeMode === 'omakase' ? 'おまかせ' : '赤' + state.types.red + ' / 白' + state.types.white + ' / 泡' + state.types.sparkling + ' / ロゼ' + state.types.rose),
          '味わい: ' + (state.tasteMode === 'omakase' ? 'おまかせ' : '赤 ' + tasteRed + ' / 白 ' + tasteWhite),
          '間隔: ' + state.cycle + '週ごと',
          '次回スキップ: ' + (skip && skip.checked ? '希望する' : 'しない')
        ];
        if (note && note.value) lines.push('補足: ' + note.value);
        if (bodyField) bodyField.value = lines.join('\n');
      });
    }

    renderTypes();
    if (tasteCustom) tasteCustom.hidden = state.tasteMode !== 'custom';
  })();
  } catch(e) { console.error(e); }
})();

})();
